import { CheckCircle2, AlertTriangle, XCircle, CalendarClock } from "lucide-react";
import { useLang } from "../i18n/LanguageContext";

export const StatusIcon = ({ status, className = "h-4 w-4" }) => {
  if (status === "valid") return <CheckCircle2 data-testid="status-icon-valid" className={`text-emerald-600 shrink-0 ${className}`} aria-label="valid" />;
  if (status === "expiring_soon") return <AlertTriangle data-testid="status-icon-expiring" className={`text-amber-500 shrink-0 ${className}`} aria-label="expiring" />;
  if (status === "expired") return <XCircle data-testid="status-icon-expired" className={`text-red-600 shrink-0 ${className}`} aria-label="expired" />;
  return null;
};

export const Countdown = ({ doc }) => {
  const { t } = useLang();
  if (!doc || doc.days_left === null || doc.days_left === undefined) return null;
  const dl = doc.days_left;
  const text = dl < 0 ? t("dash.doc.expiredSince", { n: Math.abs(dl) }) : dl === 0 ? t("dash.doc.today") : t("dash.doc.left", { n: dl });
  const cls =
    doc.status === "expired" ? "text-red-700 bg-red-50 border-red-200"
      : doc.status === "expiring_soon" ? "text-amber-700 bg-amber-50 border-amber-200"
        : "text-emerald-700 bg-emerald-50 border-emerald-200";
  return (
    <span data-testid="doc-countdown" className={`inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-xs font-mono-nums ${cls}`}>
      <CalendarClock className="h-3 w-3" /> {text}
    </span>
  );
};

// Returns the document (standard or custom) closest to expiry (smallest days_left).
export const mostUrgentDoc = (employee) => {
  const all = [];
  Object.values(employee.documents || {}).forEach((d) => {
    if (d && d.days_left !== null && d.days_left !== undefined) all.push(d);
  });
  (employee.custom_documents || []).forEach((d) => {
    if (d && d.days_left !== null && d.days_left !== undefined) all.push(d);
  });
  const c = employee.contract_status;
  if (c && c.days_left !== null && c.days_left !== undefined) all.push({ ...c, label: "العقد" });
  if (!all.length) return null;
  all.sort((a, b) => a.days_left - b.days_left);
  return all[0];
};
